import { CorrelationEndpointSource } from '../../../@types/projects/types';

type EndpointField =
  | 'sor_w'
  | 'sor_g'
  | 'sor'
  | 'kro_absolute'
  | 'krw_absolute'
  | 'krg_absolute';

const TITLE_MATRIX: Record<
  EndpointField,
  { lab: string; refinement: string }
> = {
  sor_w: {
    lab: 'Sor Correlation',
    refinement: 'Sor Refinement Correlation'
  },
  sor_g: {
    lab: 'Sor Correlation',
    refinement: 'Sor Refinement Correlation'
  },
  sor: {
    lab: 'Sorg Correlation',
    refinement: 'Sorg Refinement Correlation'
  },
  kro_absolute: {
    lab: 'Kro Absolute Correlation',
    refinement: 'Kro Refinement Correlation'
  },
  krw_absolute: {
    lab: 'Krw Absolute Correlation',
    refinement: 'Krw Refinement Correlation'
  },
  krg_absolute: {
    lab: 'Krg Absolute Correlation',
    refinement: 'Krg Refinement Correlation'
  }
};

export const getEndpointChartTitle = (
  field: EndpointField,
  source: CorrelationEndpointSource
) => TITLE_MATRIX[field][source];

const isEndpointField = (field: string): field is EndpointField =>
  field in TITLE_MATRIX;

export const getCorrelationChartTitle = (
  field: string,
  source: CorrelationEndpointSource,
  defaultTitle: string
) => {
  if (!isEndpointField(field)) {
    return defaultTitle;
  }

  return getEndpointChartTitle(field, source);
};

export const resolveEndpointValue = (
  source: CorrelationEndpointSource,
  labValue: number | null | undefined,
  refinementValue: number | null | undefined
) => {
  if (source === 'lab') {
    return {
      value: labValue ?? null,
      missingRefinement: false
    };
  }

  if (typeof refinementValue === 'number') {
    return {
      value: refinementValue,
      missingRefinement: false
    };
  }

  return {
    value: labValue ?? null,
    missingRefinement: false
  };
};
